import React, { useEffect, useState, useCallback } from "react";
import { Card, CardBody, Col, FormGroup, Input, Label, Row } from "reactstrap";
import "assets/scss/website/app.scss";
import Select from "react-select";
import "react-rangeslider/lib/index.css";
import { AvForm, AvField } from "availity-reactstrap-validation";
import CompoundService from "services/Admin/CompoundService";
import UnitTypesService from "services/Admin/UnitTypesService";
import SelectOptions from "components/Website/Select";
import { toast } from "react-toastify";
import Language from "Enums/Language";
import {
	amenitiesOptions,
	facingPlaces,
	furnishing,
	unitTypeOptions,
} from "Enums/fixedData";
import FinishingTypesService from "services/Admin/FinishingTypesService";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const StepOne = ({
	updateStateHandler,
	stateData,
	setModal,
	goBackHandler,
	inputLang,
}) => {
	const { t } = useTranslation();
	const [CompoundOpttions, setCompoundOpttions] = useState([]);
	const [propertTypes, setPropertTypes] = useState([]);
	const unitTypesService = new UnitTypesService();
	const [FinishingOptions, setFinishingOptions] = useState([]);
	const AuthData = useSelector((state) => state.Auth);
	const [standalone, setStandalone] = useState(false);
	const [anotherAmenities, setAnotherAmenities] = useState(false);

	const [formData, setFormData] = useState({
		in_compound: false,
		selectedCompound: null,
		en: "",
		ar: "",
		ru: "",
		zh: "",
		descrip_ar: "",
		descrip_en: "",
		descrip_ru: "",
		descrip_zh: "",
		propertType: null,
		facing: null,
		selectedFinishingType: null,
		floor: "",
		bedrooms: "",
		bathrooms: "",
		furnishing: null,
		total_built_up_area: "",
		total_land_area: null,
		amenities: [],
		hasAmenities: false,
	});
	const handleFieldChange = (e) => {
		setFormData({ ...formData, [e.target.name]: e.target.value });
	};

	const amenitiesArr = stateData.amenities.map((item) => {
		return { label: item, value: item };
	});

	useEffect(() => {
		setFormData({ ...stateData });
		if (!!stateData.total_land_area) {
			setStandalone(true);
		}
	}, [stateData]);

	useEffect(() => {
		unitTypesService.getDropDown().then((response) => {
			// if (response.status = SuccessOk) {
			let res = [];
			response.data?.map((prop) => {
				res.push({
					...prop.name,
					label: prop.name?.en,
					value: prop.name?.en,
					id: prop?.id,
				});
			});
			setPropertTypes([...res]);
			//            }
		});
	}, []);

	const getOptions = useCallback(
		(lang, list) => {
			return list.map((item) => {
				return {
					...item,
					label: item[`${lang}`],
				};
			});
		},
		[AuthData.lang]
	);
	const getProperty = (propertType) => {
		return propertTypes.find((item) => item.name.name === propertType);
	};
	const submitFormHandler = (e, v) => {
		if (!formData.propertType) {
			toast.error(`${"Unit Type field is required"}`);
			return;
		} else if (formData.in_compound && !formData.selectedCompound) {
			toast.error(`${t("Compound field is required")}`);
			return;
		} else if (validateDescription()) {
			return;
		} else if (!formData.selectedFinishingType) {
			toast.error(`${t("Finishing  field is required")}`);
			return;
		} else if (!formData.furnishing) {
			toast.error(`${t("Furnishing field is required")}`);
			return;
		} else if (!formData.facing) {
			toast.error(`${t("Facing field is required")}`);
			return;
		} else {
			updateStateHandler(formData);
		}
	};

	const validateDescription = () => {
		if (!!formData.descrip_en && !validate(formData.descrip_en)) {
			toast.error("Description (en) format invalid");
			return true;
		}
		// else if (!!formData.descrip_ar && !validateArabic(formData.descrip_ar)) {
		//     toast.error("Description (ar) format invalid")
		//     return true
		// }

		// else if (/^[^a-zA-Z-ء-ى]+$/.test(formData.descrip_ru)) {
		//     toast.error("Description (ru) format invalid")
		//     return true
		// } else if (/^[^a-zA-Z-ء-ى]+$/.test(formData.descrip_zh)) {
		//     toast.error("Description (zh) format invalid")
		//     return true
		// } else {
		//     return false
		// }
	};
	return (
		<AvForm
			onValidSubmit={(e, v) => submitFormHandler(e, v)}
			className="step-one">
			<p className="subtitle">
				{t(
					"List Your Property Details, Add All The Information Related To Your Property"
				)}
			</p>
			<Row className="form-content mt-4">
				<div className="box-container">
					<p className="filed-title"> {t("Choose a unit type")}</p>
					<Col md={6} className="my-3">
						<Select
							placeholder={t("select")}
							options={propertTypes}
							className="mb-3"
							value={formData.propertType}
							onChange={(e) => {
								setFormData({
									...formData,
									propertType: e,
								});
							}}
						/>
					</Col>
				</div>

				<Row className="p-2 box-container box-width">
					<Col md={6} className="mt-2">
						<h6 className="filed-title">{t("Listing in Compound")}</h6>
					</Col>
					<Col
						md={6}
						className="d-flex flex-row-reverse"
						style={{ overflow: "hidden" }}>
						<div className="form-switch form-switch-md">
							<AvField
								name="in_compound"
								checked={formData.in_compound}
								value={formData.in_compound}
								type="checkbox"
								className="form-check-input "
								id="has_status"
								onChange={(e) => {
									setFormData({
										...formData,
										[e.target.name]: e.target.checked,
									});
								}}
							/>
						</div>
					</Col>
					{formData.in_compound && (
						<Col md={6}>
							<SelectOptions
								placeholder={t("select")}
								options={CompoundOpttions}
								handleSelectChange={(data) => {
									setFormData({ ...formData, selectedCompound: data });
								}}
								selectedOption={formData.selectedCompound}
								Service={CompoundService}
								setOptions={(options) => {
									setCompoundOpttions(options);
								}}
							/>
						</Col>
					)}
				</Row>

				<Row className="my-3">
					{Language.LIST.map((lan, index) => {
						if (lan.name === inputLang) {
							return (
								<Col md={6} key={index} className="mb-3">
									<AvField
										errorMessage={t("this field is required")}
										className="style-input"
										name={lan.name}
										label={`${t("Resale Name")} (${t(lan.name)})`}
										bsSize="lg"
										value={formData[`${lan.name}`]}
										onChange={(e) => handleFieldChange(e)}
										required
										placeholder={t("Name")}
										// 	placeholder={
										// 		lan.name === "en"
										// 			? "English"
										// 			: lan.name === "ar"
										// 			? "العربية"
										// 			: lan.name === "zh"
										// 			? "中文"
										// 			: "Русский"
										// 	}
									/>
								</Col>
							);
						}
					})}
				</Row>
				{Language.LIST.map((lan, index) => {
					if (lan.name === inputLang) {
						return (
							<Col md={12} key={index} className="mb-3">
								<AvField
									className="style-input"
									name={lan.descrip_name}
									label={`${t("Description")} (${t(lan.name)})`}
									bsSize="lg"
									value={formData[`${lan.descrip_name}`]}
									onChange={(e) => handleFieldChange(e)}
									required={false}
									type="textarea"
									placeholder={t("Description")}
								/>
							</Col>
						);
					}
				})}
				<Col md={6}>
					<label>{t("Facing")}</label>
					<Select
						placeholder={t("select")}
						options={getOptions(AuthData.lang, facingPlaces)}
						className="mb-3"
						onChange={(data) => {
							setFormData({ ...formData, facing: data });
						}}
						value={formData.facing}
					/>
				</Col>
				<Col md={6}>
					<SelectOptions
						label={t("Finishing")}
						placeholder={t("select")}
						options={FinishingOptions}
						handleSelectChange={(data) => {
							setFormData({ ...formData, selectedFinishingType: data });
						}}
						selectedOption={formData.selectedFinishingType}
						Service={FinishingTypesService}
						setOptions={(options) => {
							setFinishingOptions(options);
						}}
					/>
				</Col>
				<Col md={6}>
					<label>{t("Furnishing")}</label>
					<Select
						placeholder={t("select")}
						options={getOptions(AuthData.lang, furnishing)}
						className="mb-3"
						onChange={(data) => {
							setFormData({ ...formData, furnishing: data });
						}}
						value={formData.furnishing}
					/>
				</Col>

				<Row className="mt-2">
					<Col md={6} className="mb-3">
						<AvField
							errorMessage={t("this field is required")}
							className="style-input"
							name={"bedrooms"}
							label={t("No. of Bedrooms")}
							bsSize="lg"
							value={formData.bedrooms}
							onChange={(e) => handleFieldChange(e)}
							required
							placeholder={t("bedRoom number")}
							type="number"
							min={"1"}
							max={"30"}
							pattern="/^[0-9]+$/"
						/>
					</Col>
					<Col md={6} className="mb-3">
						<AvField
							errorMessage={t("this field is required")}
							className="style-input"
							name={"bathrooms"}
							label={t("No. of Bathrooms")}
							bsSize="lg"
							value={formData.bathrooms}
							onChange={(e) => handleFieldChange(e)}
							required
							placeholder={t("bathroom number")}
							type="number"
							min={"0"}
							max={"30"}
							pattern="/^[0-9]+$/"
						/>
					</Col>
				</Row>

				<div className="d-flex justify-content-between align-itemscenter p-3 box-container box-width">
					<label className="mb-0">{t("Is the Unit Standalone?")}</label>
					<div className="form-check form-switch form-switch-md d-flex">
						<Row>
							{/* <Col md={4}>
									<Label className="mx-2">No</Label>
								</Col> */}
							<Col md={4}>
								<FormGroup check>
									<Input
										id="exampleCheck"
										name="check"
										type="checkbox"
										style={{ left: "8px" }}
										className="mt-1"
										checked={standalone}
										onChange={(e) => {
											setStandalone(e.target.checked);
										}}
									/>
								</FormGroup>
							</Col>
							{/* <Col md={4}>
									<Label>Yes</Label>
								</Col> */}
						</Row>
					</div>
				</div>
				{!standalone && (
					<Row className="mt-3">
						<Col md={6} className="mb-3">
							<AvField
								errorMessage={t("this field is required")}
								className="style-input"
								name={"total_built_up_area"}
								label={t("Total Build Up Area")}
								bsSize="lg"
								value={formData.total_built_up_area}
								onChange={(e) => handleFieldChange(e)}
								required
								placeholder={t("Total Build Up Area")}
								type="number"
								min={"1"}
								pattern="/^[0-9]+$/"
							/>
						</Col>
						<Col md={6} className="mb-3">
							<AvField
								errorMessage={t("this field is required")}
								className="style-input"
								name={"floor"}
								label={t("Floor Number")}
								bsSize="lg"
								value={formData.floor}
								onChange={(e) => handleFieldChange(e)}
								required
								placeholder={t("Floor Number")}
								type="number"
								min={"0"}
								pattern="/^[0-9]+$/"
							/>
						</Col>
					</Row>
				)}
				{standalone && (
					<Row className="mt-3">
						<Col md={6} className="mb-3">
							<AvField
								errorMessage={t("this field is required")}
								className="style-input"
								name={"total_built_up_area"}
								label={t("Build Up Area")}
								bsSize="lg"
								value={formData.total_built_up_area}
								onChange={(e) => handleFieldChange(e)}
								required
								placeholder={t("Build Up Area")}
								type="number"
								min={"1"}
								pattern="/^[0-9]+$/"
							/>
						</Col>
						<Col md={6} className="mb-3">
							<AvField
								errorMessage={t("this field is required")}
								className="style-input"
								name={"total_land_area"}
								label={t("Total Land Area")}
								bsSize="lg"
								value={formData.total_land_area}
								onChange={(e) => handleFieldChange(e)}
								required
								placeholder={t("Total Land Area")}
								type="number"
								min={"1"}
								pattern="/^[0-9]+$/"
							/>
						</Col>
						<Col md={6} className="mb-3">
							<AvField
								errorMessage={t("this field is required")}
								className="style-input"
								name={"floor"}
								label={t("Number of Floors")}
								bsSize="lg"
								value={formData.floor}
								onChange={(e) => handleFieldChange(e)}
								required
								placeholder={t("Number of Floors")}
								type="number"
								min={"0"}
								pattern="/^[0-9]+$/"
							/>
						</Col>
					</Row>
				)}
				<Row className="mb-4 p-3 box-container box-width">
					<Col md={6}>
						<label className="mb-0">Is the unit contain amenities?</label>
					</Col>
					<Col md={6} className="d-flex flex-row-reverse">
						<div className="form-check form-switch form-switch-md">
							<AvField
								name="hasAmenities"
								checked={formData.hasAmenities}
								value={formData.hasAmenities}
								type="checkbox"
								className="form-check-input m-0"
								id="has_status"
								onChange={(e) => {
									setFormData({
										...formData,
										[e.target.name]: e.target.checked,
									});
								}}
							/>
						</div>
					</Col>
					{formData.hasAmenities ? (
						<Col md={6}>
							<Select
								isMulti
								name="amenities"
								className="basic-multi-select mt-3"
								classNamePrefix="select"
								options={[
									...amenitiesOptions,
									{ label: "Other", value: "Other" },
								]}
								value={formData.amenities}
								onChange={(e) => {
									const unique = [];
									setAnotherAmenities(false);
									e?.filter((ele) => {
										if (!unique?.includes(ele.label)) {
											unique.push(ele);
											if (ele.label === "Other") {
												setAnotherAmenities(true);
											}
										}
									});
									setFormData({ ...formData, amenities: unique });
								}}
							/>
						</Col>
					) : null}
					{(anotherAmenities ||
						!!formData.amenities?.filter((item) => item.label === "Other")
							.length) &&
						formData.hasAmenities && (
							<Col md={12}>
								<AvField
									name={"amenitiesOther"}
									label={"Amenities Name"}
									bsSize="lg"
									value={formData?.amenitiesOther[`${inputLang}`]}
									onChange={(e) =>
										setFormData({
											...formData,
											amenitiesOther: {
												...formData.amenitiesOther,
												label: e.target.value,
												[inputLang]: e.target.value,
											},
										})
									}
									required
									errorMessage="This field is required"
									placeholder={"Amenitie Name"}
									type="textarea"
								/>
							</Col>
						)}
				</Row>

				<Row className="my-4">
					<Col md={9}>
						<button
							type="button"
							style={{ borderRadius: "5px", width: "15%" }}
							className="btn btn-light btnHeight cancel  text-center"
							onClick={() => setModal(true)}>
							{t("Cancel")}
						</button>
					</Col>
					<Col md={3} className="d-flex justify-content-between">
						<button
							type="button"
							onClick={() => {
								updateStateHandler(formData);
								goBackHandler();
							}}
							className="btn btn-light back btnHeight text-center"
							style={{ borderRadius: "5px", width: "45%" }}>
							{t("Back")}
						</button>
						<button
							type="submit"
							style={{
								borderRadius: "5px",
								width: "45%",
								borderColor: "var(--primary-color)",
								background: "var(--primary-color)",
							}}
							className="btn btn-success next btnHeight text-center ">
							{t("Next")}
						</button>
					</Col>
				</Row>
			</Row>
		</AvForm>
	);
};

let validate = (str) => {
	let count = 0;
	for (let i = 0; i < str.length; i++) {
		if (
			(str.charCodeAt(i) >= 65 && str.charCodeAt(i) <= 90) ||
			(str.charCodeAt(i) >= 97 && str.charCodeAt(i) <= 122)
		) {
			count += 1;
		}
	}

	return count >= 2 ? true : false;
};

let validateArabic = (str) => {
	let count = 0;
	for (let i = 0; i < str.length; i++) {
		if (str.charCodeAt(i) >= 1569 && str.charCodeAt(i) <= 1610) {
			count += 1;
		}
	}
	return count >= 2 ? true : false;
};
export default StepOne;
